'use strict';

var _security = require('./_security.module');

var _security2 = _interopRequireDefault(_security);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_security2.default.directive('claimAuthorize', ['ngIfDirective', 'authService', function (ngIfDirective, authService) {
    var ngIf = ngIfDirective[0];

    return {
        transclude: ngIf.transclude,
        priority: ngIf.priority,
        terminal: ngIf.terminal,
        restrict: ngIf.restrict,
        link: function link($scope, $element, $attr) {
            var claim = $attr.claimAuthorize;
            var value = $scope.$eval($attr.claimValue);
            //var yourCustomValue = $scope.$eval(claim);

            $attr.ngIf = function () {
                return authService.hasClaim(claim, value);
            };
            ngIf.link.apply(ngIf, arguments);
        }
    };
}]); /*jshint esversion: 6 */
/* http://stackoverflow.com/questions/20325480/angularjs-whats-the-best-practice-to-add-ngif-to-a-directive-programmatically */


//////////////////
// WEBPACK FOOTER
// ./blocks/security/claimsAuthorize.directive.js
// module id = 698
// module chunks = 0